import { render, staticRenderFns } from "./image-uploader.vue?vue&type=template&id=95ec903a&scoped=true"
import script from "./image-uploader.vue?vue&type=script&lang=js"
export * from "./image-uploader.vue?vue&type=script&lang=js"
import style0 from "./image-uploader.vue?vue&type=style&index=0&id=95ec903a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ec903a",
  null
  
)

export default component.exports